module.exports = __webpack_public_path__ + "img/photo-0105.64ad4593.jpg";